<template>
  <div class="wrapper">
    <swiper :options="swiperOption" ref="swiper" @slideChangeTransitionEnd="addDeaf"  v-bind:key="rerenderer">
    <template v-for='movie in movies'>
      <swiper-slide class="swipervideo" :data-video="'/videos/Ausstellung/' + movie.video" :data-audio="movie.audio" v-bind:key="movie.url">
        <img :data-src="srcpath + movie.url" class="swiper-lazy"/>
            <div class="swiper-lazy-preloader-white"></div>
      </swiper-slide>
    </template>
    </swiper>
    <div title="geh zurück" class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
    <div title="geh weiter" class="swiper-button-next swiper-button-white" slot="button-next"></div>
  </div>
</template>

<style>
</style>

<script>
import s2data from '../../json/ausstellung.json'
export default {
  name: 'ASSmain',
  components: {
  },
  data () {
    return {
      movies: s2data,
      deaf: true,
      active: '',
      src: 'A-Audio.mp3',
      windowWidth: 0,
      swiperOption: {
        preloadImages: false,
        centeredSlides: false,
        slidesPerView: 2,
        spaceBetween: 0,
        lazy: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1500: {
            slidesPerView: 1,
            spaceBetween: 0
          }
        }
      }
    }
  },
  computed: {
    srcpath () {
      if (this.$store.state.srcpath) {
        return '/img/ausstellung/'
      } else {
        return '/img/ausstellung/english/'
      }
    },
    showSubMenu () {
      return this.$store.state.showSubMenu
    },
    rerenderer () {
      return this.$store.state.rerender
    }
  },
  methods: {
    addDeaf () {
      if (this.$store.state.deaf === true) {
        this.active = document.getElementsByClassName('swiper-slide-active')[0]
        if (this.active.dataset.video === '/videos/Ausstellung/novideo') {
          document.getElementsByTagName('video')[0].src = ''
        } else {
          document.getElementsByTagName('video')[0].src = this.active.dataset.video
          document.getElementsByTagName('video')[0].play()
        }
      }
      if (this.$store.state.mute === true) {
        this.active = document.getElementsByClassName('swiper-slide-active')[0]
        if (this.src !== this.active.dataset.audio) {
          this.src = this.active.dataset.audio
          console.log(this.active.dataset.audio)
          document.getElementsByTagName('source')[0].src = '/mp3/' + this.active.dataset.audio
          document.getElementsByTagName('audio')[0].load()
        }
      }
    }
  },
  mounted () {
    document.body.style.background = 'rgb(92, 192, 202)'
    // change color
    document.getElementsByTagName('nav')[0].style.background = 'rgb(92, 192, 202)'
    // showsubmenu
    this.$store.commit('toggleMenu', true)
    this.$store.state.deaf = false
  }
}
</script>

<style scoped>
/* Sind anonsten nicht klickbar */
.swiper-slide img{
  height:auto !important;
  max-width: 100% !important;

}

.swiper-button-prev{
  margin-left:120px;
}

.swiper-button-next{
  margin-right:135px;
}

@media (orientation: portrait) and (min-width:415px){

/* Die Swiper werden links und rechts vom Rand entfernt. Ist mit Pixeln überhaupt keine gute Idee, aber mit fällt da gerade nichts besseres ein. */

.swiper-button-white{
  display:none;
}

.swiper-slide img{
  max-height:100vh;
  width: auto;
}

}

@media (orientation: portrait) and (max-width:414px){

.swiper-button-white{
  display:none;
}

.swiper-slide img{
  max-height:100vh;
  width: calc(100vw - 75px);
}

}

@media (orientation: landscape) {
  .swiper-slide img{
    max-height:100vh;
    width: auto;
  }
}

@media (orientation: landscape){
  .swiper-container{
    margin-left: 150px;
  }
}

@media (orientation: landscape) and (max-height: 414px){
  .swiper-button-white{
    display:none;
  }
}

</style>
